export class HoldSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HoldSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
